export default {"src":"/gallery/_next/static/media/logo.97941423.svg","height":30,"width":107,"blurWidth":0,"blurHeight":0};